import { mockCLPQuotePersonInfo } from '@domgen/dgx-fe-basket';
import { mockBrandRetailer } from '@domgen/dgx-fe-catalogue';
import { startOfToday } from 'date-fns';
import { ApplianceDetailsSteppedFormValue } from '../../models/appliance-details-stepped/appliance-details-stepped-form-value.type';

export const mockApplianceDetailsSteppedFormValue: ApplianceDetailsSteppedFormValue =
  {
    applianceCategoryCode: 'WM',
    applianceCode: 'CN',
    applianceCodeBuiltIn: false,
    brandCode: 'AEG',
    partsWarranty: null,
    person: mockCLPQuotePersonInfo,
    purchaseDate: startOfToday(),
    purchasePrice: 300,
    retailer: mockBrandRetailer.name,
    warranty: 12,
    modelAndSerialNumber: {
      modelNumber: null,
      serialNumber: null,
    },
  };
